import { render, staticRenderFns } from "./OneTimeVerification.vue?vue&type=template&id=3ff99c06&"
import script from "./OneTimeVerification.vue?vue&type=script&lang=js&"
export * from "./OneTimeVerification.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CModalHeader: require('@chakra-ui/vue').CModalHeader, CModalCloseButton: require('@chakra-ui/vue').CModalCloseButton, CText: require('@chakra-ui/vue').CText, CInput: require('@chakra-ui/vue').CInput, CLink: require('@chakra-ui/vue').CLink, CBox: require('@chakra-ui/vue').CBox, CModalBody: require('@chakra-ui/vue').CModalBody, CModalContent: require('@chakra-ui/vue').CModalContent, CModalOverlay: require('@chakra-ui/vue').CModalOverlay, CModal: require('@chakra-ui/vue').CModal})
